import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { UserTabBar } from "./UserTabBar";
import { resolveUserTab, type UserTabId } from "./userTabs";
import { RequestsSection } from "../RequestsSection/RequestsSection";
import { PolicyCheckSection } from "../PolicyCheckSection/PolicyCheckSection";
import { ItCheckSection } from "../ItCheckSection/ItCheckSection";
import "../AdminWorkspace/AdminWorkspace.scss";

export const UserWorkspace = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolveUserTab(searchParams.get("tab"));

  const handleTabChange = useCallback(
    (tab: UserTabId) => {
      setSearchParams({ tab }, { replace: true });
    },
    [setSearchParams]
  );

  return (
    <div className="admin-workspace">
      <div className="admin-workspace__tabs-card">
        <UserTabBar activeTab={activeTab} onTabChange={handleTabChange} />
      </div>
      <div className="admin-workspace__content-card">
        {activeTab === "policy-checks" ? (
          <PolicyCheckSection embedded />
        ) : activeTab === "it-checks" ? (
          <ItCheckSection embedded returnTab="it-checks" />
        ) : (
          <RequestsSection embedded />
        )}
      </div>
    </div>
  );
};
